module.exports = __webpack_public_path__ + "static/media/uca.d71d6332.webp";